<template>
    <div class="add-event-type">
        <div style="display: flex; justify-content: space-between;align-items: center">
        </div>
        <div slot="content">
            <div class="centered vue-loader" style="height: 350px" v-if="loading">
                <vue-loader></vue-loader>
            </div>
            <div v-else
                 style="display: flex; justify-content: center; align-items: center; height: 70vh; flex-direction: column">
                <h2>Profile</h2>
                <loader v-if="loading" style="height: 350px"></loader>
                <el-form v-else ref="addBusCompany" :model="current_user" :rules="formRules"
                         label-position="left"
                         class="add-base-card">
                    <el-form-item label="Email" prop="userEmail">
                        <el-input disabled v-model="current_user.userEmail"></el-input>
                    </el-form-item>
                    <el-form-item label="Password" prop="newPassword">
                        <el-input show-password v-model="current_user.newPassword"></el-input>
                    </el-form-item>
                    <el-button style="width: 100%" type="primary" size="medium" @click="save()">Save</el-button>

                </el-form>

            </div>

        </div>

    </div>
</template>
<script>
    import {mapState} from 'vuex';
    import {LoaderIcon} from 'vue-feather-icons'
    import UserService from '@/common/services/user.service'
    import Loader from "../common/components/loader";

    export default {
        name: "Profile",
        components: {
            Loader,
            VueLoader: LoaderIcon
        },
        data() {
            return {
                loading: false,
                current_user: {
                    userEmail: null,
                    newPassword: null,
                },

                formRules: {
                    userEmail: {
                        required: true,
                        trigger: 'change',
                    },
                    newPassword: {
                        required: true,
                        trigger: 'change',
                    },

                },
            }
        },
        computed: {
            ...mapState({
                user_email: state => state.user.user_email,
            })
        },
        methods: {
            save() {
                this.$refs['addBusCompany'].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        this.current_user.newPassword = this.current_user.newPassword.toString();
                        UserService.updatePassword(this.current_user).then(() => {
                            this.$notify.success({
                                title: `Bus`,
                                message: 'Successfully updated password'
                            });
                        }).catch(error => {
                            this.$notify.error({
                                title: `Failed to update password`,
                                message: error.response.data.message
                            });
                        }).finally(() => this.loading = false)
                    } else {
                        return false;
                    }
                })
            },
        },
        beforeMount() {
            this.current_user.userEmail = this.user_email
        }
    }
</script>
<style scoped lang="scss">

    .add-base-card {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        bottom: 0;
        background-color: white;
        border-radius: 5px;
        min-width: 400px;
        padding: 20px;
        -webkit-box-shadow: 0 0 5px #c7c1c1
    }

    .add-event-type {
        h3 {
            margin: 0;
        }

        padding: 20px;

        .add-buttons {
            display: flex;
            justify-content: space-between;
            margin-top: 10px;

            .add-button {
                background-color: #efefef;
                border: 1px solid lightgray;
                width: 100%;
                padding: 10px 0;
                cursor: pointer;
            }
        }

        .form {
            height: 350px;

            .no-image-container {
                background-color: #f8f8f8;
                display: flex;
                width: 100%;
                height: 150px;
                cursor: pointer;

                .no-image-contents {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    flex-direction: column;
                    border-radius: 4px;
                }
            }

            .image-container {
                display: flex;
                justify-content: center;
                border: 1px solid #DCDFE6;
                border-radius: 4px;
                cursor: pointer;
            }

            .file-select {

            }

            .avatar-uploader .el-upload {
                border: 1px dashed #d9d9d9;
                border-radius: 6px;
                cursor: pointer;
                position: relative;
                overflow: hidden;
            }

            .avatar-uploader .el-upload:hover {
                border-color: #409EFF;
            }

            .avatar-uploader-icon {
                font-size: 28px;
                color: #8c939d;
                height: 178px;
                line-height: 178px;
                text-align: center;
            }

            .avatar {
                width: 178px;
                height: 178px;
                display: block;
            }

        }

        .footer-btn {
            display: flex;
            justify-content: flex-end;
        }

    }
</style>
